import "./ModuleCard.css"; // Importação do CSS
import UserCard from "../UserCard";
import usersIcon from "../../../../assets/users_icon.svg";
import plusIcon from "../../../../assets/plus_icon.svg";
import { FaEyeSlash, FaGlobe } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import LoadingSpinner from "../LoadingSpinner"; // Importação do componente de loading
import SubsidiaryCard from "../SubsidiaryCard";

function ModuleCard({
  module,
  manualUsers,
  subsidiaries,
  manualUserCount,
  handleRemoveUser,
  handleAddUser,
  handleRemoveUserModal,
  loading,
}) {
  return (
    <div className="module-group-card">
      <div className="module-group-header">
        <div className="title-module-card">
          <h3 className="module-title">{module.pageName}</h3>
        </div>
        <div className="icons-module-card">
          <div className="user-count">
            {manualUserCount}
            <img src={usersIcon} alt="users icon" className="user-count-icon" />
          </div>
          <button
            className="remove-user-button-modulecard"
            onClick={handleRemoveUserModal}
          >
            <FaTrash />
          </button>
          <button className="add-user-button" onClick={handleAddUser}>
            <img src={plusIcon} alt="plus icon" />
          </button>
        </div>
      </div>

      {/* Mostrar o indicador de carregamento se estiver carregando */}
      {loading ? (
        <div className="loading-container">
          <LoadingSpinner />
        </div>
      ) : (
        <div className="module-group-content">
          {/* Modulo Oculto */}
          {((!module.isVisibleForAll && module.subsidiaries.length === 0) ||
            module.manualUserCount === 0) && (
            <div className="hidden-badge">
              <span className="badge-icon">
                <FaEyeSlash />
              </span>
              <span className="badge-text">
                Visible only to manually added Users
              </span>
            </div>
          )}

          {/* Modulo visivel pra todos */}
          {module.isVisibleForAll && (
            <div className="visible-for-all-badge">
              <span className="badge-icon">
                <FaGlobe color="white" />
              </span>
              <span className="badge-text">Visible to All Users</span>
            </div>
          )}

          {/* Seção de usuários manuais */}
          {manualUsers.length > 0 && (
            <div className="manual-users-section">
              <h4 className="section-title">
                Manual Users ({manualUsers.length})
              </h4>
              <div className="users-list">
                {manualUsers.map((user) => (
                  <UserCard
                    key={user.email}
                    user={user}
                    onRemove={() => handleRemoveUser(user.email, module.id)}
                  />
                ))}
              </div>
            </div>
          )}

          {/* Seção de subsidiárias */}
          {subsidiaries.length > 0 && (
            <div className="subsidiaries-section">
              <h4 className="section-title">Subsidiaries with Access</h4>
              <div className="subsidiaries-list">
                {subsidiaries.map((sub) => (
                  <SubsidiaryCard key={sub.id} subsidiary={sub} />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ModuleCard;
